import React, {useState} from "react";

import CRD_STATS from './crd_stats/crd_stats';
import CRD_DOMAINS from './crd_domains/crd_domains';

import './domains_list.css';


export default function DOMAINS_LIST() {

  //  variable declarations ------------------------------------------------------------------------------------------

  const [currentStatus, setCurrentStatus] = useState('DOMAINS');



  //  event listeners ------------------------------------------------------------------------------------------------



  //  async functions ------------------------------------------------------------------------------------------------



  //  API calls ------------------------------------------------------------------------------------------------------



  //  event functions ------------------------------------------------------------------------------------------------



  // RENDER CONTAINER ================================================================================================

  return (
    <div id='page--domains_list' className='page'>
      <div className='page__header'>
        <div className='text--xl medium'>Domains</div>
      </div>

      <CRD_STATS
        currentStatus={currentStatus}
        onStatusChange={setCurrentStatus}
      />

      <CRD_DOMAINS
        status={currentStatus}
      />
    </div>
  );

}